import { render, staticRenderFns } from "./AtricleVideoRecommend.vue?vue&type=template&id=14586620&scoped=true&"
import script from "./AtricleVideoRecommend.vue?vue&type=script&lang=js&"
export * from "./AtricleVideoRecommend.vue?vue&type=script&lang=js&"
import style0 from "./AtricleVideoRecommend.vue?vue&type=style&index=0&id=14586620&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14586620",
  null
  
)

export default component.exports